<template>
  <div class="itemObj flex" :style="{ height: height, marginBottom: '12px' }" @click="parkClick(item)">
    <div class="titleBox flexR">
      <span>{{ item.parkingName || '' }}</span>
      <div class="distance">
        <img :src="require('@/assets/home/distance.png')" class="img" />{{ item.distance || 0 }} km
      </div>
    </div>
    <div class="bottomBox flexR">
      <div style="flex: 1; height: 100%">
        <div class="address span-overflow2">{{ item.parkingAddress }}</div>
        <div :class="['numBox', item.warningColor === '红' ? 'red' : item.warningColor === '黄' ? 'yellow' : '']">
          <div class="tip flexR">
            {{ item.warningColor === '红' ? '紧张' : item.warningColor === '黄' ? '适中' : '充足' }}
          </div>
          <div class="num flexR">
            <span>剩余车位</span>
            <span class="numText">{{ item.parkingMargin || 0 }}</span>
            <span> · 共{{ item.parkingNumber || 0 }}</span>
          </div>
        </div>
      </div>
      <div class="daohang flexC" @click.stop="dhClick(item)">
        <img :src="require('@/assets/home/daohang.png')" class="img" />
        <span>导航</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParkItem',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    height: {
      type: String,
      default: '134px',
    },
  },
  components: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    //导航事件
    dhClick(ite) {
      this.$emit('dhClick', ite)
    },
    parkClick(ite) {
      this.$emit('parkClick', ite)
    },
  },
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.flexR {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.flexC {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.itemObj {
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
  padding: 12px;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  .titleBox {
    height: 24px;
    font-weight: 500;
    font-size: 16px;
    color: #1a1a1a;
    line-height: 24px;
    margin-bottom: 8px;
    .distance {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-weight: 400;
      font-size: 13px;
      color: #19bdbf;
      line-height: 21px;
      .img {
        width: 15px;
        height: 15px;
        margin-right: 4px;
      }
    }
  }
  .bottomBox {
    flex: 1;
    height: 0;
    .address {
      font-size: 12px;
      color: #787878;
      line-height: 21px;
      margin-bottom: 9px;
    }
    .numBox {
      height: 25px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .tip {
        height: 100%;
        font-weight: 700;
        font-size: 12px;
        color: #ffffff;
        line-height: 17px;
        box-sizing: border-box;
        padding: 0 6px;
        background: #19bdbf;
        border-radius: 2px 0px 0px 2px;
      }
      .num {
        height: 100%;
        font-size: 12px;
        color: #787878;
        line-height: 21px;
        box-sizing: border-box;
        padding: 0 6px;
        border-radius: 0 2px 2px 0;
        border: 1px solid #19bdbf;
        border-left: none;
        .numText {
          font-weight: 500;
          font-size: 16px;
          color: #19bdbf;
          line-height: 23px;
          margin: 0 4px;
        }
      }
    }
    .yellow {
      .tip {
        background: #f6bd00;
      }
      .num {
        border: 1px solid #f6bd00;
        .numText {
          color: #f6bd00;
        }
      }
    }
    .red {
      .tip {
        background: #e43131;
      }
      .num {
        border: 1px solid #e43131;
        .numText {
          color: #e43131;
        }
      }
    }
    .daohang {
      font-size: 12px;
      color: #787878;
      line-height: 21px;
      margin-left: 60px;
      .img {
        width: 32px;
        height: 32px;
        margin-bottom: 2px;
      }
    }
  }
}
</style>
